
import {mapActions, mapGetters, mapMutations} from "vuex";
import IoablePageMixin from "@/router/IoablePageMixin";
import TabPageTemplate from "@/components/templates/TabPageTemplate.vue";
import TradeContractView, {createTradeContractView} from "@/components/pages/contract/TradeContract/TradeContractView";
import IconBtn from "@/components/molecules/IconBtn.vue";
import SimpleDialog from "@/components/organisms/SimpleDialog.vue";
import {defineComponent} from "vue";
import {TradeContract} from "@/store/modules/hcs/tradeContract/model";
import {AxiosInstance} from "axios";
import ProfileManagementLoaderMixin from "@/components/pages/profile/ProfileManagement/LoaderMixin";

export default defineComponent({
  name: 'TradeContractList',
  components: {
    SimpleDialog,
    TabPageTemplate,
    IconBtn,
  },
  mixins: [
    IoablePageMixin.extend({
      beforeRouteUpdate(to, from, next) {
        next();
      }
    }),
    ProfileManagementLoaderMixin,
  ],
  data() {
    return {
      tradeContracts: [] as TradeContractView[],
      deleteDialog: {
        visible: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account',
      hcsClient: 'hcs/client',
    }),
  },
  methods: {
    ...mapMutations({
      showSnackbar: 'showSnackbar'
    }),
    ...mapActions({
      fetchTradeContractFormatGroups: "hcs/tradeContractFormatGroup/findList",
    }),
    async load() {
      const hcsClient = this.hcsClient as AxiosInstance;
      const {data: tradeContracts} = await hcsClient.get<TradeContract[]>('/trade_contracts');
      this.tradeContracts = tradeContracts.map(tc => createTradeContractView(tc, this.$store));
    },
    async deleteTradeContract(tradeContractId: string) {
      this.showSnackbar({
        message: '取引契約を削除中...',
        timeout: false,
        loading: true
      });

      this.deleteDialog.visible = false;
      try {
        // とりあえず表示から消す
        this.tradeContracts = this.tradeContracts.filter(tc => tc.id !== tradeContractId);

        // 取引契約の削除
        await this.$store.dispatch('hcs/tradeContract/delete', tradeContractId);

        this.showSnackbar({
          message: '取引契約を削除しました',
        });
      } catch (e) {
        console.error(e);
        this.showSnackbar({
          color: 'failed',
          message: '取引契約の削除に失敗しました',
        });
      }
    },
    tabRoute(name: string) {
      const routeBase = this.$route.name?.replace(/^(\/[^/]+\/[^/]+\/[^/]+).*$/, '$1');
      return `${routeBase}${name}`;
    }
  },
});
